export function tableOptionsToQueryParams(page, tableOptions) {
    page= page||1;
    return {
        $skip:(page-1)*tableOptions.options.itemsPerPage, 
        $limit:tableOptions.options.itemsPerPage
    }
}